<script setup>
import HeroSection    from '@/pages/Home/parts/HeroSection.vue'
import AboutSection   from '@/pages/Home/parts/AboutSection.vue'
import HowToSection   from '@/pages/Home/parts/HowToSection.vue'
import FairPlaySection from '@/pages/Home/parts/FairPlaySection.vue'
</script>

<template>
  <main class="home">
    <HeroSection />
    <AboutSection />
    <HowToSection />
    <FairPlaySection />
  </main>
</template>

<style scoped>
/*
  BackgroundField.vue already provides the fixed ARK panorama.
  This page is transparent — sections use glass panels or sit
  directly on the dark photographic backdrop.
*/
.home {
  width: 100%;
  min-height: 100vh;
  /* no background — let BackgroundField show through */
}
</style>
